module.exports = __webpack_public_path__ + "media/images/country_flags/cy-e463e37afe864a6ef56dc9a103c75fde.png";